import Swiper, { Navigation, Pagination } from "swiper"

export default class ShopPartners {

  constructor (el) {
    this.el = el
    this.slider = null
    this.prev = this.el.querySelector('.swiper-navigation__btn--prev')
    this.next = this.el.querySelector('.swiper-navigation__btn--next')
    this.pagination = this.el.querySelector('.swiper-navigation__pagination')
  }

  init () {

    this.slider = new Swiper(this.el, {
      modules: [ Navigation, Pagination ],
      spaceBetween: 24,
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchOverflow: true,
      centerInsufficientSlides: true,
      observer: true,
      navigation: {
        prevEl: this.prev,
        nextEl: this.next
      },
      pagination: {
        el: this.pagination
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 24
        },
        1025: {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 60
        },
        1601: {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 80
        }
      },
      on: {
        'init': (swiper) => {
          swiper.navigation?.destroy();
          const breakpoint = swiper.getBreakpoint(swiper.params.breakpoints);
          const currentBreakpoint = swiper.params.breakpoints?.[breakpoint];
          const { navigation: currentBreakpointNavConfig } = currentBreakpoint || {};

          if (!currentBreakpointNavConfig) {
              return;
          }

          if (currentBreakpointNavConfig === true || currentBreakpointNavConfig?.enabled) {
              swiper.navigation.init();
              swiper.navigation.update();
          }
        },
        'lock': () => {
          this.el.classList.add('locked')
        },
        'unlock': () => {
          this.el.classList.remove('locked')
        }
      }
    })

  }

}